
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $c07e664aae562e1f$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"IOlTS\",\"SpaceSettingsNavigationPortal.8a3b94fd.js\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.c31d80d1.js\",\"eMbU0\",\"SpaceSelector.111c7bdd.js\",\"3wN5D\",\"ExternalSpaceLozenge.11ec98f6.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"etEYy\",\"FullPageEditorComponent.65cdb6b1.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.19de6a7a.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.5831a241.js\",\"7EorR\",\"vendors~editor_atlaskit_md.0d9e3504.js\",\"2QTNW\",\"FullPageEditorComponent.4fc56546.js\",\"cj0Rr\",\"FullPageEditorComponent.1eb25710.js\",\"7Bi4V\",\"FullPageEditorComponent.ed41f0ec.js\",\"3ufWD\",\"FullPageEditorComponent.runtime.14f6a969.js\",\"gepVN\",\"component-lazy.ae5692bf.js\",\"4iy7m\",\"CommentsPanelFooter.dbac05ea.js\",\"1FTmX\",\"esm.16794325.js\",\"7TbZ2\",\"esm.bbd1fe77.js\",\"7mo6o\",\"FullPageEditorComponent.bf4a22a4.js\",\"6bVVs\",\"FullPageEditorComponent.runtime.e64e02ff.js\",\"8W6BK\",\"SpaceSelector.ec35209e.js\",\"ffEVr\",\"vendors~editor_icon.687efc82.js\",\"89ROx\",\"CommentEditor.f8ae61ac.js\",\"b7Mr5\",\"CommentEditor.runtime.19397850.js\",\"6nxM7\",\"SpaceSelector.dfc0f4ec.js\",\"dtpmo\",\"SpaceSelector.ead533ff.js\",\"6wr18\",\"vendors~editor_icon.e2c5f0e9.js\",\"gYr8z\",\"blockSubscription.8414eb2c.js\",\"b7Mr5\",\"CommentEditor.runtime.19397850.js\",\"6bVVs\",\"FullPageEditorComponent.runtime.e64e02ff.js\",\"3ufWD\",\"FullPageEditorComponent.runtime.14f6a969.js\",\"4yUSc\",\"PremiumLozenge.1c0eef16.js\",\"ePA5l\",\"Lozenge.0b4adf81.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"5pvpJ\",\"CommentEditor.0720ad71.js\",\"cEqm7\",\"ExtensionConfigUpsell.81a24740.js\",\"6XCf4\",\"LearnMoreButton.602bf661.js\",\"1yVM6\",\"UpgradeEditionButton.bdca6a5e.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.736c14d8.js\",\"hOaAV\",\"ExtensionConfigUpsell.01b2ff5f.js\",\"7JvFY\",\"CreateSpaceDrawer.7cfeeb72.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.736c14d8.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\"]"));


$parcel$global.rlb("DNq0w")
//# sourceMappingURL=SpaceSettingsNavigationPortal.runtime.2a25f255.js.map
